import React from "react";
import { Switch, Route } from "react-router-dom";
import { RouterList } from './routerList';

export const Routes = (props) =>(<Switch>
    { RouterList.map( (route, i) => (<Route key ={ i } exact path ={route.path} history = { props.history }  component = { route.component } />))}
</Switch>)